import { render, staticRenderFns } from "./LayoutVertical.vue?vue&type=template&id=48ec5ecc&scoped=true"
import script from "./LayoutVertical.vue?vue&type=script&lang=js"
export * from "./LayoutVertical.vue?vue&type=script&lang=js"
import style0 from "./LayoutVertical.vue?vue&type=style&index=0&id=48ec5ecc&prod&lang=scss&scoped=true"
import style1 from "./LayoutVertical.vue?vue&type=style&index=1&id=48ec5ecc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ec5ecc",
  null
  
)

export default component.exports